import { render } from "./TrackParcel.vue?vue&type=template&id=21606bcd&scoped=true"
import script from "./TrackParcel.vue?vue&type=script&lang=js"
export * from "./TrackParcel.vue?vue&type=script&lang=js"

import "./TrackParcel.vue?vue&type=style&index=0&id=21606bcd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21606bcd"]])

export default __exports__